<template>
    <button class="blueBtn" :name="name" v-on:click="onClick" :disabled="disabled">
        <img v-if='withCheck' :src='loadIconCheck' alt='' class='icon-check'>
        {{ text }}
    </button>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'BoutonBleu',
    props: {
        text: { type: String, required: true },
        onClick: { type: Function, required: true },
        name: { type: String, required: false },
        disabled: { type: Boolean, required: false },
        withCheck: { type: Boolean, required: false },
    },
    computed: {
        loadIconCheck() {
            return require('@/assets/img/icons/checkBlanc.png');
        },
    }
});
</script>

<style scoped>
.blueBtn {
    border: none;
    background-color: blue;
    color: var(--white);
    font-size: var(--font-size-small);
    font-weight: var(--font-weight-normal);
    height: 38px;
    padding: 0 8px;
    border-radius: 6px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
}
.blueBtn:disabled {
    background-color: var(--button-color-disabled);
    cursor: default;
}
.icon-check {
    float: left;
}
</style>
